import { SET_SHOW_ART_WALL_FILTERS } from './../const';

export default (showArtWallFilters) => {
  return {
    type: SET_SHOW_ART_WALL_FILTERS,
    showArtWallFilters: showArtWallFilters
  }
};
